import { Box, Stack, useTheme } from "@mui/material";
import { ActivitiesListV2Group } from "web_myplann/Activities/Components/ActivitiesListV2Group";
import { useActivitiesList } from "web_myplann/Activities/Hooks/useActivitiesList";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";
import { NativePullToRefresh } from "web_myplann/Shared/Components/NativePullToRefresh";
import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

const ListResources = Resources.Activity.List;

export const ActivitiesListV2Page = () => {
	const { t } = useResource();
	const theme = useTheme();

	const {
		solvedEvents,
		upcomingEvents,
		overdueEvents,
		resolvedEvents,
		isLoading,
		allSectionsEmpty,
		hasOtherSections,
	} = useActivitiesList();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(ListResources.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			{isLoading && (
				<StyledCenteredStack spacing={2} px={5} zIndex={10}>
					<RowSkeletonLoader />
					<RowSkeletonLoader />
					<RowSkeletonLoader />
				</StyledCenteredStack>
			)}

			<Box sx={{ opacity: isLoading ? 0 : 1, transition: "opacity 0.2s" }}>
				<NativePullToRefresh
					queryKeys={[
						TaskKeys.lists(),
						ActivityKeys.lists(),
						ActivityKeys.events(),
					]}
					spinnerOffset={-20}
				>
					{allSectionsEmpty ? (
						<EmptyListSkeleton
							label={t(ListResources.NoContent)}
							description={t(ListResources.NoActivities)}
							data-testid="activities-list-page"
						/>
					) : (
						<Stack pt={0.8} pb={2} gap={0.8} data-testid="activities-list-page">
							<ActivitiesListV2Group
								label={t(Resources.Common.solvedEvents)}
								group={solvedEvents}
								emptyText={
									hasOtherSections ? t(ListResources.NoTask) : undefined
								}
							/>
							<ActivitiesListV2Group
								label={t(Resources.Common.upcomingEvents)}
								group={upcomingEvents}
								emptyText={t(ListResources.NoUpcomingEvents)}
							/>
							<ActivitiesListV2Group
								label={t(Resources.Common.overdueEvents)}
								group={overdueEvents}
								emptyText={t(ListResources.NoOverdueEvents)}
							/>
							<ActivitiesListV2Group
								label={t(Resources.Common.resolvedEvents)}
								group={resolvedEvents}
								emptyText={t(ListResources.NoResolvedEvents)}
							/>
						</Stack>
					)}
				</NativePullToRefresh>
			</Box>
		</MyPlannLayout>
	);
};
